import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#111111] shadow-lg">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-20">
          {/* Logo/Brand */}
          <a 
            href="/" 
            className="flex items-center"
            data-testid="header-logo"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_intake-hub-6/artifacts/l9bs5fno_Cletis%20Logo.png"
              alt="Red River Internet Auto Sales"
              className="h-16 md:h-20 w-auto object-contain"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a
              href="tel:+13467187187"
              className="flex items-center gap-2 text-white bg-[#A52A2A] hover:bg-[#8B2323] px-5 py-2.5 rounded-md font-bold uppercase tracking-wide text-sm transition-all"
              data-testid="nav-call-btn"
            >
              <Phone className="w-4 h-4" />
              Call Now
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-white"
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800 animate-fadeIn">
            <nav className="flex flex-col gap-4">
              <a
                href="tel:+13467187187"
                className="flex items-center justify-center gap-2 text-white bg-[#A52A2A] hover:bg-[#8B2323] px-5 py-3 rounded-md font-bold uppercase tracking-wide text-sm transition-all"
                data-testid="mobile-call-btn"
              >
                <Phone className="w-4 h-4" />
                Call Now
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
